<template>
  <div class="activity">
    <div style="width: 1200px; margin: 0 auto">
      <div style="width: 100%; height: 50px"></div>
      <div style="
          line-height: 26px;
          font-size: 26px;
          font-family: MicrosoftYaHei;
          font-weight: 400;
          color: #000000;
        ">
        活动<span style="
            line-height: 18px;
            font-size: 18px;
            font-family: MicrosoftYaHei;
            font-weight: 400;
            color: #666666;
            margin-left: 10px;
          ">Activities</span>
      </div>
      <div style="width: 54px; height: 2px; background: #3476c1; margin-top: 20px"></div>
      <div style="
          width: 1200px;
          margin: 30px auto 0;
          display: flex;
          flex-wrap: wrap;
          justify-content: space-between;
        ">
        <div class="activity-i" @click="toDetail(item.activityId)" v-for="(item, index) in data.activityList"
          :key="index">
          <div style="width: 285px; height: 200px;overflow:hidden">
            <!-- <img src="../../static/activity/act2.png" alt="" style="width:100%;display:block;"> -->
            <img class="hover" v-if="item.coverImg" :src="item.coverImg" alt="" style="width: 100%; display: block" />
          </div>
          <div style="" class="activity-i-t">{{ item.activityName }}</div>
          <div style="" class="activity-i-txt">{{ item.remark }}</div>
        </div>
        <div v-for="(item, index) in jiaArr" :key="index + 100" style="width: 285px; height: 200px"></div>
      </div>
      <div style="clear: both"></div>
      <!-- <div style="width:150px;height:40px;line-height:40px;text-align:center;background:rgba(0,0,0,1);border-radius:20px;margin:0 auto;margin-top:10px;font-size:14px;font-family:MicrosoftYaHei;font-weight:400;color:rgba(255,255,255,1);">更多活动</div> -->
      <div class="morezanserve" @click="toMore">更多活动</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "activity",
  data() {
    return {
      jiaArr: [],
      data: {
      },
    };
  },
  methods: {
    toMore() {
      sessionStorage.setItem("tabIndex", 5);
      this.$router.push("/activity");
    },
    // toDetail(id){
    //     sessionStorage.setItem('tabIndex',5);
    //     this.$router.push({
    //         path: '/activityDetail',
    //         query: {
    //             activityId: id,
    //         }
    //     })
    // },
    toDetail(activityId) {
      sessionStorage.setItem("tabIndex", 5);
      this.$router.push({
        path: "/activityDetail",
        query: {
          activityId,
          catalogueId: this.data.catalogueId,
          catalogueName: this.data.catalogueName,
        },
      });
    },
  },
  created() {
    //活动
    this.$axios
      .get("/v1/cloud/common/activity/home", {})
      .then(({ data }) => {
        if (data) {
          data.activityList.forEach(function (item, index) {
            item.remark = item.remark.substr(0, 34) + "...";
          });
          this.data = data;
          this.jiaArr = this.data.activityList.length < 8 ? 8 - this.data.activityList.length : 0
        }
      })
      .catch((error) => {
        this.$message({
          message: error.response.data.message,
          type: "warning",
        });
      });
  },
  mounted() { },
};
</script>

<style scoped lang="less">
img.hover {
  transition: all 1s
}

img.hover:hover {
  transition: all 1.5s;
  transform: scale(1.3);
}

.activity {
  width: 100%;
  height: 961px;
  background: #F5F5F5;

  .activity-i {
    width: 285px;
    height: 342px;
    background: #fff;
    margin-bottom: 30px;
    cursor: pointer;

    .activity-i-t {
      width: 100%;
      padding-left: 10px;
      height: 16px;
      line-height: 16px;
      font-size: 16px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #333333;
      margin: 19px 0px 10px 0px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    .activity-i-txt {
      width: 100%;
      padding-left: 10px;
      padding-right: 10px;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 400;
      color: #888888;
      line-height: 25px;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 3;
      -webkit-box-orient: vertical;
      min-height: 75px;
    }
  }

  .activity-i:hover {
    box-shadow: 1px 20px 50px 0px rgba(207, 207, 207, 1);
  }

  .activity-i:hover .activity-i-t {
    color: #3476C1;
  }

  .morezanserve {
    margin: 10px auto 0;
    width: 150px;
    height: 40px;
    border: 1px solid #5fc0e4;
    border-radius: 3px;
    line-height: 40px;
    color: #5FC0E4;
    box-sizing: border-box;
    text-indent: 34px;
    background-image: url('../../static/common/morezan.png');
    background-size: 15px 15px;
    background-repeat: no-repeat;
    background-position: 101px 12px;
    cursor: pointer;
  }

  .morezanserve:hover {
    background-color: #5FC0E4;
    background-image: url('../../static/common/morezan1.png');
    color: #fff;
  }
}
</style>